import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';

if (environment.production) {
  enableProdMode();
}

function bootstrapApp() {
  platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
}

if (typeof (window as any).geotab !== 'undefined' && (window as any).geotab.addin) {
  if(window.location.href.includes('dev')) {
    (window as any).geotab.addin.bitcDev = () => ({
      initialize(api: any, state: any, callback: () => void) {
        api.getSession((session: any) => {
          sessionStorage.removeItem(`credentials_${environment.appId}`);
          sessionStorage.setItem(`credentials_${environment.appId}`, JSON.stringify(session));
          bootstrapApp();
          callback();
        });
      },
      focus(api: any, state: any) {
        api.getSession((session: any) => {
          sessionStorage.removeItem(`credentials_${environment.appId}`);
          sessionStorage.setItem(`credentials_${environment.appId}`, JSON.stringify(session));
        });
      },
      blur(api: any, state: any) {
        sessionStorage.removeItem(`credentials_${environment.appId}`);
      }
    });
  } else {
    (window as any).geotab.addin.bitc = () => ({
      initialize(api: any, state: any, callback: () => void) {
        api.getSession((session: any) => {
          sessionStorage.removeItem(`credentials_${environment.appId}`);
          sessionStorage.setItem(`credentials_${environment.appId}`, JSON.stringify(session));
          bootstrapApp();
          callback();
        });
      },
      focus(api: any, state: any) {
        api.getSession((session: any) => {
          sessionStorage.removeItem(`credentials_${environment.appId}`);
          sessionStorage.setItem(`credentials_${environment.appId}`, JSON.stringify(session));
        });
      },
      blur(api: any, state: any) {
        sessionStorage.removeItem(`credentials_${environment.appId}`);
      }
    });
  }
  
} else {
  bootstrapApp();
}